import { render, staticRenderFns } from "./playerStats.vue?vue&type=template&id=6f42b70a&scoped=true"
import script from "./playerStats.vue?vue&type=script&lang=js"
export * from "./playerStats.vue?vue&type=script&lang=js"
import style0 from "./playerStats.vue?vue&type=style&index=0&id=6f42b70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42b70a",
  null
  
)

export default component.exports